import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface NotificationsState {
    feedUnreadCount: number
    chatUnreadCount: number
}

const initialState: NotificationsState = {
    feedUnreadCount: 0,
    chatUnreadCount: 0,
}

export const NotificationsSlice = createSlice({
    name: 'notificationsReducer',
    initialState,
    reducers: {
        setFeedUnreadCount(state, action: PayloadAction<number>): NotificationsState {
            return {
                ...state,
                feedUnreadCount: action.payload,
            }
        },
        setChatUnreadCount(state, action: PayloadAction<number>): NotificationsState {
            return {
                ...state,
                chatUnreadCount: action.payload,
            }
        },
    },
})

export const {
    setFeedUnreadCount,
    setChatUnreadCount,
} = NotificationsSlice.actions

export const notificationsReducer = NotificationsSlice.reducer
